import './main.less';
import React from 'react';
import AddGeoForm from './add-geo-form';

const Main = props => {
	return (
		<div className="container__content programs-list">
			<div className="table-container">
				<table className="simple-table offers-table additional-offers-table">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							<th>
								Location
								<p className="order-action-btn order-action-btn--reorder">
									<span onClick={props.toggleReorder}>Reorder</span>
								</p>
							</th>
							<th> Free leads at geo </th>
							<th> Approves plan </th>
							<th> Actions </th>
						</tr>
					</thead>
					<tbody className="simple-table__body">
						{
							props.rows.map((row, index) =>
								props.editingGeoCode === row.country_code
									? <AddGeoForm
										key={index}
										{...props}
										initialValues={{...row, country_code: [{ value: row.country_code, label: row.country_name }]}}
										isEdit={true}
									/>
									: <Row {...props} row={row} key={index}/>
							)
						}
						<AddGeoForm {...props} />
					</tbody>
				</table>
			</div>
		</div>
	);
};

const Row = props =>
	<tr>
		<td>{props.row.country_name}</td>
		<td>{props.row.free_leads}</td>
		<td>{props.row.approves_plan}</td>
		<td className="actions">
			<a
				className="action_edit margin-0-10"
				onClick={props.setEditingCountryCode.bind(null, props.row.country_code)}
			/>
			<a
				className="action_delete"
				onClick={() =>
					props.removeLocationPlan(props.row.country_code)
						.then(props.updateLocationsData)
				}
			/>
		</td>
	</tr>;

export default Main;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/locations-plan/table.js